import { getUserConfiguration } from 'owa-session-store';

export function readWorkLifeViewFromUserConfig(): number {
    let workLifeViewOption = 0;

    const primeSettings = getUserConfiguration().PrimeSettings;

    const calendarSurfaceOptions = primeSettings?.Items?.filter(
        item => item.Id == 'CalendarSurfaceOptions'
    );
    if (calendarSurfaceOptions) {
        workLifeViewOption = calendarSurfaceOptions[0].Value.options[0].workLifeView;
    }

    return workLifeViewOption;
}
